//Library Imports
import styled from "styled-components";

// CSS Imports
import "./global.css";

// CSS-in-JS
export const MagicBlackBtn = styled.button`
  &::before {
    content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAwTDUuMTc1MjkgMS44MjQ3MUw3IDIuNUw1LjE3NTI5IDMuMTc1MjlMNC41IDVMMy44MjQ3MSAzLjE3NTI5TDIgMi41TDMuODI0NzEgMS44MjQ3MUw0LjUgMFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNi41IDEzTDE3LjE3NTMgMTUuMTg5NkwxOSAxNkwxNy4xNzUzIDE2LjgxMDRMMTYuNSAxOUwxNS44MjQ3IDE2LjgxMDRMMTQgMTZMMTUuODI0NyAxNS4xODk2TDE2LjUgMTNaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTMuMDQ2OSAwLjI5MjQ3MUMxMy4yMjg4IC0wLjA5NzQ5MDIgMTMuNzcxMiAtMC4wOTc0OTAyIDEzLjk1MzEgMC4yOTI0NzFMMTUuNDg0OSAzLjU3NjM5QzE1LjUyOTYgMy42NzIxNyAxNS42MDIxIDMuNzUxNDYgMTUuNjkyNyAzLjgwMzMzTDE4Ljc0MzIgNS41NTE3NEMxOS4wODU2IDUuNzQ3OTMgMTkuMDg1NiA2LjI1MjAyIDE4Ljc0MzIgNi40NDgyMkwxNS42OTI3IDguMTk2NjVDMTUuNjAyMSA4LjI0ODU0IDE1LjUyOTYgOC4zMjc3NiAxNS40ODQ5IDguNDIzNTNMMTMuOTUzMSAxMS43MDc1QzEzLjc3MTIgMTIuMDk3NSAxMy4yMjg4IDEyLjA5NzUgMTMuMDQ2OSAxMS43MDc1TDExLjUxNTEgOC40MjM1M0MxMS40NzA0IDguMzI3NzYgMTEuMzk3OSA4LjI0ODU0IDExLjMwNzMgOC4xOTY2NUw4LjI1Njc1IDYuNDQ4MjJDNy45MTQ0MiA2LjI1MjAyIDcuOTE0NDIgNS43NDc5MyA4LjI1Njc1IDUuNTUxNzRMMTEuMzA3MyAzLjgwMzMzQzExLjM5NzkgMy43NTE0NiAxMS40NzA0IDMuNjcyMTcgMTEuNTE1MSAzLjU3NjM5TDEzLjA0NjkgMC4yOTI0NzFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMy41NDUyMiAxMC4yNjkzQzMuNzI0NDkgOS45MTAyMyA0LjI3NTU0IDkuOTEwMjMgNC40NTQ4MSAxMC4yNjkzTDUuNDYzMzggMTIuMjg5OEM1LjUwNzEyIDEyLjM3NzQgNS41NzkyNSAxMi40NTAyIDUuNjY5NzYgMTIuNDk4MUw3Ljc0NzM5IDEzLjU5NjlDOC4wODQyIDEzLjc3NTEgOC4wODQyIDE0LjIyNDkgNy43NDczOSAxNC40MDMxTDUuNjY5NzYgMTUuNTAxOUM1LjU3OTI1IDE1LjU0OTggNS41MDcxMiAxNS42MjI2IDUuNDYzMzggMTUuNzEwMkw0LjQ1NDgxIDE3LjczMDdDNC4yNzU1NCAxOC4wODk4IDMuNzI0NDkgMTguMDg5OCAzLjU0NTIyIDE3LjczMDdMMi41MzY2NSAxNS43MTAyQzIuNDkyOTEgMTUuNjIyNiAyLjQyMDc3IDE1LjU0OTggMi4zMzAyNyAxNS41MDE5TDAuMjUyNjUgMTQuNDAzMUMtMC4wODQyMTY3IDE0LjIyNDkgLTAuMDg0MjE2NyAxMy43NzUxIDAuMjUyNjUgMTMuNTk2OUwyLjMzMDI3IDEyLjQ5ODFDMi40MjA3NyAxMi40NTAyIDIuNDkyOTEgMTIuMzc3NCAyLjUzNjY1IDEyLjI4OThMMy41NDUyMiAxMC4yNjkzWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==");
    position: relative;
    top: 3px;
    left: -6px;
  }

  font-family: Roboto;
  width: ${({ width }) => width || "241px"};
  height: ${({ height }) => height || "56px"};
  border-radius: 100px;
  background-color: var(--bg-color-raisin-black);
  color: var(--text-color-white);
  font-size: var(--size20);
  font-weight: var(--fw400);
  line-height: var(--lh23);
  text-align: center;
  outline: none;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  border: 1px solid #242424;
  transition: background-color 0.3s ease, border 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: var(--bg-color-outer-space);
    border: 1px solid #595959;
    color: var(--text-color-pumpkin);
  }
`;
